import { Helper } from '../Helper';
export class RawIteratorEveryHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorEveryBase({
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorEveryHelper.js.map
